export default __webpack_public_path__ + "static/media/home1-banner2.c12acb88.jpg";